import PageLayout from '../../components/page-layout';
import ElevationUnknownNotice from '../_shared/ElevationUnknownNotice';
import { useElevatedAdminAccess } from '../organization/hooks/useIsElevatedAdmin';
import AccessControlSettingsCard from './components/AccessControlSettingsCard';
import AccessLogsTable from './components/AccessLogsTable';

export default function AccessControlPage() {
  // `AccessControlSettingsCard` renders nothing unless elevation came back
  // `true`, which is right for an operator the API answered `false` about and
  // wrong for one it never answered at all: the door configuration for their
  // venue simply was not on the page, with nothing said. The card stays
  // fail-closed; the page says why it is short.
  const { state: elevationState } = useElevatedAdminAccess();

  return (
    <PageLayout>
      {elevationState === 'unknown' && <ElevationUnknownNotice />}
      <AccessControlSettingsCard />
      <AccessLogsTable />
    </PageLayout>
  );
}
